const uaParser = new UAParser();
const os = uaParser.getOS() || {};
const device = uaParser.getDevice() || {};
const browser = uaParser.getBrowser() || {};
let platformName = '';

if (window.forcePlatform) {
  platformName = window.forcePlatform;
} else if (os.name === 'Windows') {
  platformName = 'win';
} else if (os.name === 'Mac OS') {
  platformName = 'mac';
}

if (platformName) {
  document.body.classList.add(platformName);
} else {
  document.body.classList.add('other-platform');
}

const isMobile = (
  os.name === 'iOS'
  || os.name === 'Android'
  || device.type === 'mobile'
  || device.type === 'tablet'
  || device.type === 'wearable'
);

export {
  platformName,
  os,
  device,
  browser,
  isMobile,
};
